import React from 'react';
import { useParams } from 'react-router-dom';
import ContractLineVersionListing from './contract-line-version-listing';

const ContractLineVersion = () => {
  const { contractHeaderId, versionNumber } = useParams();
  return (
    <ContractLineVersionListing key={`${contractHeaderId}-${versionNumber}`} />
  );
};

export default ContractLineVersion;
